import React, { useEffect, useState } from "react";

const SubMenu = ({ submenu, isOpen = true, title }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Small delay to trigger animation after DOM render
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 10);

      return () => {
        clearTimeout(timer);
      };
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  return (
    <div
      className="overflow-hidden"
      style={{
        maxHeight: isVisible ? "600px" : "0",
        transition: "max-height 300ms cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      <div
        className={`
          bg-white shadow-2xl px-8 xl:px-[7.875rem]
          transition-all duration-300 transform origin-top
          ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
          }
        `}
      >
        <div className="flex justify-center p-6">
          <div className="max-w-screen-xl mx-auto w-full">
            <div
              className="grid gap-6 w-full"
              style={{
                gridTemplateColumns: `repeat(${Math.min(submenu.length, 5)}, minmax(0, 300px))`,
                justifyContent: 'center',
              }}
            >
            {submenu.map((section) => (
              <div key={section.id} className="flex flex-col space-y-3">
                {section.type === "buttons" ? (
                  /* Handle button-only sections without title */
                  <div className="flex flex-col space-y-2">
                    {section.children && section.children.map((child) => (
                      <a
                        key={child.id}
                        href={child.url}
                        className={`
                          px-5 py-2 text-sm font-semibold text-center transition-all duration-200 hover:no-underline block rounded-full
                          ${child.style === "ghost"
                            ? "border-2 border-muotolevy-button text-muotolevy-button hover:bg-muotolevy-button hover:text-white"
                            : "bg-muotolevy-button text-white hover:bg-muotolevy-yellow hover:text-white"
                          }
                        `}
                      >
                        {child.title}
                      </a>
                    ))}
                  </div>
                ) : section.sections ? (
                  /* Handle sections that contain multiple subsections */
                  <div className="flex flex-col">
                    {section.sections.map((subsection, index) => (
                      <div
                        key={subsection.id}
                        className={`flex flex-col space-y-3 ${index > 0 ? "mt-3" : ""}`}
                      >
                        <a
                          href={subsection.url}
                          className="text-base font-semibold text-gray-800 hover:text-muotolevy-red transition-colors duration-200 hover:no-underline block"
                        >
                          {subsection.title}
                        </a>
                        {subsection.children &&
                          subsection.children.length > 0 && (
                            <div className="flex flex-col space-y-2">
                              {subsection.children.map((child) => (
                                <a
                                  key={child.id}
                                  href={child.url}
                                  className="text-base text-gray-600 hover:text-muotolevy-red transition-colors duration-200 hover:no-underline block pl-2"
                                >
                                  {child.title}
                                </a>
                              ))}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                ) : (
                  /* Handle regular sections */
                  <>
                    <a
                      href={section.url}
                      className="text-base font-semibold text-gray-800 hover:text-muotolevy-red transition-colors duration-200 hover:no-underline block"
                    >
                      {section.title}
                    </a>

                    {/* Handle children if they exist */}
                    {section.children && section.children.length > 0 && (
                      <div className="flex flex-col space-y-2">
                        {section.children.map((child) => (
                          /* Check if child should be rendered as a button */
                          child.type === "button" ? (
                            <a
                              key={child.id}
                              href={child.url}
                              className={`
                                px-5 py-2 text-sm font-semibold text-center transition-all duration-200 hover:no-underline block rounded-full
                                ${child.style === "ghost" 
                                  ? "border-2 border-muotolevy-button text-muotolevy-button hover:bg-muotolevy-button hover:text-white"
                                  : "bg-muotolevy-button text-white hover:bg-muotolevy-yellow hover:text-white"
                                }
                              `}
                            >
                              {child.title}
                            </a>
                          ) : (
                            <a
                              key={child.id}
                              href={child.url}
                              className="text-base text-gray-600 hover:text-muotolevy-red transition-colors duration-200 hover:no-underline block pl-2"
                            >
                              {child.title}
                            </a>
                          )
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubMenu;
